import { useErrorToast } from "components/toast/ToastComponet";
import {
  FindCardsDashboard,
  FindClientsByCRTFunction,
  FindClientsByTEF,
  FindClientsListDashboard,
  FindCRTSGraphics,
  FindTEFs,
  FindTermalsVersions,
  FindVersionsModule,
} from "functions/Dashboard";
import type {
  FindClientsListTypes,
  FindCardsDashboardTypes,
  FindVersionsModuleTypes,
  FindTEFsType,
  FindCRTSGraphicsTypes,
  TerminaisVersaoProps,
  CompanyByNameTypes,
  FindClientsByTEFTypes,
  ResponseFindClientsByTEFTypes,
	FindClientsByCRTParms,
	ResponseFindClientsByCRTTypes,
} from "types/DashbordTypes";

export function UseDashboard() {
  const toast = useErrorToast();
  const findCardsDashboard = async (): Promise<FindCardsDashboardTypes> => {
    try {
      const resp: FindCardsDashboardTypes = await FindCardsDashboard();
      return resp;
    } catch (error: any) {
      toast(error.response.data.error);
      throw error.response.data.error;
    }
  };

  const findClientsListDashboard = async (
    days: number
  ): Promise<FindClientsListTypes[]> => {
    try {
      const resp: FindClientsListTypes[] = await FindClientsListDashboard(days);
      return resp;
    } catch (error: any) {
      toast(error.response.data.error);
      throw error.response.data.error;
    }
  };

  const findVersionsModule = async (
    days: number,
    module: string
  ): Promise<FindVersionsModuleTypes> => {
    try {
      const resp: FindVersionsModuleTypes = await FindVersionsModule(
        days,
        module
      );
      return resp;
    } catch (error: any) {
      toast(error.response.data.error);
      throw error.response.data.error;
    }
  };

  const findTEFsByDate = async (days: number): Promise<FindTEFsType[]> => {
    try {
      const resp: FindTEFsType[] = await FindTEFs(days);
      return resp;
    } catch (error: any) {
      toast(error.response.data.error);
      throw error.response.data.error;
    }
  };

  const findCRTsGraphic = async (
    days: number
  ): Promise<FindCRTSGraphicsTypes[]> => {
    try {
      const resp: FindCRTSGraphicsTypes[] = await FindCRTSGraphics(days);
      return resp;
    } catch (error: any) {
      toast(error.response.data.error);
      throw error.response.data.error;
    }
  };

  const findTerminalVersions = async (
    parms: TerminaisVersaoProps
  ): Promise<PaginateProps<CompanyByNameTypes>> => {
    try {
      const resp: PaginateProps<CompanyByNameTypes> = await FindTermalsVersions(
        parms
      );
      return resp;
    } catch (error: any) {
      toast(error.response.data.error);
      throw error.response.data.error;
    }
  };

  const findTEFsClientsByTEFid = async (
    parms: FindClientsByTEFTypes
  ): Promise<PaginateProps<ResponseFindClientsByTEFTypes[]>> => {
    try {
      const resp: PaginateProps<ResponseFindClientsByTEFTypes[]> =
        await FindClientsByTEF(parms);
      return resp;
    } catch (error: any) {
      toast(error.response.data.error);
      throw error.response.data.error;
    }
  };

  const findClientsByCRT = async (
    parms: FindClientsByCRTParms
  ): Promise<PaginateProps<ResponseFindClientsByCRTTypes[]>> => {
    try {
      const resp: PaginateProps<ResponseFindClientsByCRTTypes[]> =
        await FindClientsByCRTFunction(parms);
      return resp;
    } catch (error: any) {
      toast(error.response.data.error);
      throw error.response.data.error;
    }
  };

  return {
    findCardsDashboard,
    findClientsListDashboard,
    findVersionsModule,
    findTEFsByDate,
    findCRTsGraphic,
    findTerminalVersions,
    findTEFsClientsByTEFid,
		findClientsByCRT
  };
}
